module.exports = __webpack_public_path__ + "img/kyouzai_shape.ba266fdc.png";